import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import * as DataList from 'components/DataList';

// Layout shared by the list and its loading skeleton (components/Billing/History.js).
export const TRANSACTION_COLUMNS = [
  { area: 'invoice', label: 'Invoice', width: 'minmax(110px, 0.8fr)', bone: 'single' },
  { area: 'transaction', label: 'Transaction ID', width: 'minmax(180px, 1.4fr)', bone: 'single', icon: 'barcode' },
  { area: 'date', label: 'Date', width: 'minmax(130px, 1fr)', bone: 'short', icon: 'calendar' },
  { area: 'amount', label: 'Amount', width: 'minmax(100px, 0.8fr)', bone: 'short', icon: 'dollar' },
  { area: 'status', label: 'Status', width: 'minmax(110px, 0.8fr)', bone: 'pill' },
  { area: 'actions', label: '', width: '56px', bone: 'none' },
];

export const TRANSACTION_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['invoice actions', 'status status', 'transaction transaction', 'date date'],
  footer: ['amount'],
};

export const TRANSACTION_MIN_TABLE_WIDTH = 720;

const STATUS_TONES = {
  paid: 'green',
  succeeded: 'green',
  success: 'green',
  pending: 'amber',
  processing: 'amber',
  failed: 'red',
  declined: 'red',
  refunded: 'grey',
};

const sentenceCase = (text) => (text ? String(text).charAt(0).toUpperCase() + String(text).slice(1).replace(/_/g, ' ') : '');

// Billing > Billing history: one row per payment, with a link to its invoice.
@inject('viewStore') @observer
class PaymentTransactions extends Component {
  render() {
    const { objects, viewStore } = this.props;
    return (
      <DataList.List
        columns={TRANSACTION_COLUMNS}
        cards={TRANSACTION_CARDS}
        minTableWidth={TRANSACTION_MIN_TABLE_WIDTH}
        total={objects.length}
        noun="payments"
      >
        {objects.map((transaction) => {
          const a = transaction.attributes;
          const status = a.status ? String(a.status).toLowerCase() : '';
          return (
            <DataList.Row key={a.id || transaction.id}>
              <DataList.Cell area="invoice">
                <DataList.Lines primary={a.invoice_number ? `#${a.invoice_number}` : '–'} />
              </DataList.Cell>
              <DataList.Cell area="transaction">
                <span className="bill-mono">{a.transaction_id}</span>
              </DataList.Cell>
              <DataList.Cell area="date">{a.transaction_date_formatted}</DataList.Cell>
              <DataList.Cell area="amount">
                <span className="sp-number">${a.amount_paid}</span>
              </DataList.Cell>
              <DataList.Cell area="status">
                {status ? <DataList.Pill tone={STATUS_TONES[status] || 'grey'}>{sentenceCase(status)}</DataList.Pill> : <DataList.Muted>–</DataList.Muted>}
              </DataList.Cell>
              <DataList.Cell area="actions">
                <DataList.Actions
                  items={[
                    a.invoice_id && {
                      icon: 'document-open',
                      label: `View invoice${a.invoice_number ? ` #${a.invoice_number}` : ''}`,
                      onClick: () => viewStore.ShowInvoice({ uuid: a.invoice_id }),
                    },
                  ]}
                />
              </DataList.Cell>
            </DataList.Row>
          );
        })}
      </DataList.List>
    );
  }
}

export default PaymentTransactions;
